export default "__VITE_ASSET__CZyJWtqK__"